import { Monitor, Moon, Sun } from "lucide-react";
import { useThemeStore } from "@/app/store/theme.store";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils/cn";

const icons = { light: Sun, dark: Moon, system: Monitor };
const labels = { light: "Light", dark: "Dark", system: "System" };

export function ThemeToggle({ compact = false, className }) {
  const { theme, toggleTheme } = useThemeStore();
  const Icon = icons[theme];

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggleTheme}
      className={cn(compact && "h-8 w-8 rounded-lg", className)}
      // The label names the current state, not the next one, so a screen
      // reader user knows where they are before deciding to change it.
      aria-label={`Theme: ${labels[theme]}. Change theme`}
      title={`Theme: ${labels[theme]}`}
    >
      <Icon className="h-4 w-4" />
    </Button>
  );
}
